import { CircularProgress, Box, SxProps } from '@mui/material';

type LoadingProps = {
  td?: boolean;
  unstyled?: boolean;
};
const Loading = (props: LoadingProps) => {
  const Wrap = props.td ? 'td' : Box;

  const getSxStyles = (): SxProps => {
    if (props.unstyled) return {};

    const baseStyles: SxProps = {
      flex: 1,
      display: 'flex',
      width: '100%',
      height: '100%',
      alignItems: 'center',
      justifyContent: 'center',
    };

    return props.td
      ? { ...baseStyles, paddingTop: '15px', minHeight: 'auto' }
      : { ...baseStyles, minHeight: '70vh' };
  };

  return (
    <Wrap sx={getSxStyles()}>
      <CircularProgress />
    </Wrap>
  );
};

export default Loading;
